export default __webpack_public_path__ + "static/media/targetprocess.06be013c.svg";